<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-israeldefenses-box">
  <!-- Artboard: xs -->
  <div
    id="g-israeldefenses-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.5;"
  >
    <div
      id="g-israeldefenses-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/israeldefenses-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:7.0823%;margin-top:-6.6px;left:62.4945%;margin-left:-67.5px;width:135px;"
    >
      <p class="g-pstyle0">Missile interception</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:26.1166%;margin-top:-6.5px;left:77.6938%;margin-left:-25.5px;width:51px;"
    >
      <p class="g-pstyle1">Space</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:42.4802%;margin-top:-6.5px;left:78.2847%;margin-left:-59.5px;width:119px;"
    >
      <p class="g-pstyle1">Earth&rsquo; s atmosphere</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.3893%;margin-top:-11.5px;right:3.3055%;width:54px;"
    >
      <p class="g-pstyle2">Missile</p>
      <p class="g-pstyle2">launch</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:63.8439%;margin-top:-6.5px;left:0.1454%;width:52px;"
    >
      <p class="g-pstyle3">Target</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:63.8439%;margin-top:-6.5px;left:12.0237%;width:49px;"
    >
      <p class="g-pstyle3">70km</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:63.8439%;margin-top:-6.5px;left:23.3996%;width:56px;"
    >
      <p class="g-pstyle3">300km</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:63.8439%;margin-top:-6.5px;left:55.779%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle4">1000km</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:63.8439%;margin-top:-6.5px;right:0.5124%;width:63px;"
    >
      <p class="g-pstyle5">2000km</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:93.3893%;margin-top:-12.5px;left:9.6743%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle6">IRON</p>
      <p class="g-pstyle6">DOME</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:93.3893%;margin-top:-12.5px;left:22.685%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle6">DAVID&rsquo;S</p>
      <p class="g-pstyle6">SLING</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.1166%;margin-top:-6.5px;left:34.337%;width:69px;"
    >
      <p class="g-pstyle7">ARROW 2</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.1166%;margin-top:-6.5px;left:59.1906%;width:69px;"
    >
      <p class="g-pstyle7">ARROW 3</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-israeldefenses-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.82142857142857;"
  >
    <div
      id="g-israeldefenses-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/israeldefenses-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:3.7789%;margin-top:-7.6px;left:59.9316%;margin-left:-67.5px;width:135px;"
    >
      <p class="g-pstyle0">Missile interception</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="transform: matrix(0.9028,-0.4302,0.4302,0.9028,0,0);transform-origin: 50% 42.5603022377216%;-webkit-transform: matrix(0.9028,-0.4302,0.4302,0.9028,0,0);-webkit-transform-origin: 50% 42.5603022377216%;-ms-transform: matrix(0.9028,-0.4302,0.4302,0.9028,0,0);-ms-transform-origin: 50% 42.5603022377216%;top:18.4218%;margin-top:-7.6px;left:32.9519%;margin-left:-70.5px;width:141px;"
    >
      <p class="g-pstyle1">Missile planned path</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:26.9932%;margin-top:-7.6px;left:73.8681%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle2">Space</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:46.6361%;margin-top:-7.6px;left:73.8132%;margin-left:-72.5px;width:145px;"
    >
      <p class="g-pstyle2">Earth&rsquo; s atmosphere</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:59.8504%;margin-top:-14.6px;right:5.615%;width:62px;"
    >
      <p class="g-pstyle3">Missile</p>
      <p class="g-pstyle3">launch</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:70.2075%;margin-top:-7.6px;right:92.4666%;width:60px;"
    >
      <p class="g-pstyle4">Target</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:70.2075%;margin-top:-7.6px;left:12.3637%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle5">70km</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:70.2075%;margin-top:-7.6px;left:24.8412%;margin-left:-32.5px;width:65px;"
    >
      <p class="g-pstyle5">300km</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:70.2075%;margin-top:-7.6px;left:52.4561%;margin-left:-35.5px;width:71px;"
    >
      <p class="g-pstyle5">1000km</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:70.2075%;margin-top:-7.6px;right:0.3588%;width:74px;"
    >
      <p class="g-pstyle4">2000km</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:93.0647%;margin-top:-14.6px;left:9.9741%;width:61px;"
    >
      <p class="g-pstyle6">IRON</p>
      <p class="g-pstyle6">DOME</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:93.0647%;margin-top:-14.6px;left:21.4524%;width:73px;"
    >
      <p class="g-pstyle6">DAVID&rsquo;S</p>
      <p class="g-pstyle6">SLING</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.5647%;margin-top:-7.6px;left:36.4204%;width:82px;"
    >
      <p class="g-pstyle6">ARROW 2</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.5647%;margin-top:-7.6px;left:61.3685%;width:82px;"
    >
      <p class="g-pstyle6">ARROW 3</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-israeldefenses-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.94117647058824;"
  >
    <div
      id="g-israeldefenses-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/israeldefenses-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.7885%;margin-top:-8.1px;left:59.5329%;margin-left:-67.5px;width:135px;"
    >
      <p class="g-pstyle0">Missile interception</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="transform: matrix(0.8926,-0.4508,0.4508,0.8926,0,0);transform-origin: 50% 40.9755882612144%;-webkit-transform: matrix(0.8926,-0.4508,0.4508,0.8926,0,0);-webkit-transform-origin: 50% 40.9755882612144%;-ms-transform: matrix(0.8926,-0.4508,0.4508,0.8926,0,0);-ms-transform-origin: 50% 40.9755882612144%;top:21.7885%;margin-top:-8.1px;left:31.7045%;margin-left:-70.5px;width:141px;"
    >
      <p class="g-pstyle1">Missile planned path</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.0238%;margin-top:-8.1px;left:73.681%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle2">Space</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:61.2003%;margin-top:-8.1px;left:73.6386%;margin-left:-72.5px;width:145px;"
    >
      <p class="g-pstyle2">Earth&rsquo; s atmosphere</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:65.7591%;margin-top:-15.6px;right:5.4454%;width:62px;"
    >
      <p class="g-pstyle3">Missile</p>
      <p class="g-pstyle3">launch</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:75.0238%;margin-top:-8.1px;right:94.1133%;width:60px;"
    >
      <p class="g-pstyle4">Target</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:75.0238%;margin-top:-8.1px;left:11.1667%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle5">70km</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:75.0238%;margin-top:-8.1px;left:21.6593%;margin-left:-32.5px;width:65px;"
    >
      <p class="g-pstyle5">300km</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:75.0238%;margin-top:-8.1px;left:51.932%;margin-left:-35.5px;width:71px;"
    >
      <p class="g-pstyle5">1000km</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:75.0238%;margin-top:-8.1px;right:0.1261%;width:74px;"
    >
      <p class="g-pstyle4">2000km</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:92.2297%;margin-top:-15.6px;left:8.7432%;width:61px;"
    >
      <p class="g-pstyle6">IRON</p>
      <p class="g-pstyle6">DOME</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:92.2297%;margin-top:-15.6px;left:20.411%;width:73px;"
    >
      <p class="g-pstyle6">DAVID&rsquo;S</p>
      <p class="g-pstyle6">SLING</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:94.4356%;margin-top:-8.1px;left:35.6263%;width:82px;"
    >
      <p class="g-pstyle6">ARROW 2</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:94.4356%;margin-top:-8.1px;left:60.9866%;width:82px;"
    >
      <p class="g-pstyle6">ARROW 3</p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-israeldefenses-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 2;"
  >
    <div
      id="g-israeldefenses-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/israeldefenses-lg.jpg);"
    ></div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.5192%;margin-top:-8.7px;left:60.398%;margin-left:-75.5px;width:151px;"
    >
      <p class="g-pstyle0">Missile interception</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="transform: matrix(0.8854,-0.4648,0.4648,0.8854,0,0);transform-origin: 50% 36.7062314540059%;-webkit-transform: matrix(0.8854,-0.4648,0.4648,0.8854,0,0);-webkit-transform-origin: 50% 36.7062314540059%;-ms-transform: matrix(0.8854,-0.4648,0.4648,0.8854,0,0);-ms-transform-origin: 50% 36.7062314540059%;top:22.5084%;margin-top:-8.7px;left:31.0211%;margin-left:-78.5px;width:157px;"
    >
      <p class="g-pstyle1">Missile planned path</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:34.7665%;margin-top:-8.7px;left:74.5156%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle2">Space</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:61.8632%;margin-top:-8.7px;left:74.5195%;margin-left:-81.5px;width:163px;"
    >
      <p class="g-pstyle2">Earth&rsquo; s atmosphere</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:65.7342%;margin-top:-16.7px;right:4.5718%;width:68px;"
    >
      <p class="g-pstyle3">Missile</p>
      <p class="g-pstyle3">launch</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:75.1966%;margin-top:-8.7px;right:93.7304%;width:66px;"
    >
      <p class="g-pstyle4">Target</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:75.4116%;margin-top:-8.7px;left:12.08%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle5">70km</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:75.4116%;margin-top:-8.7px;left:22.5496%;margin-left:-35.5px;width:71px;"
    >
      <p class="g-pstyle5">300km</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:75.4116%;margin-top:-8.7px;left:52.8099%;margin-left:-39px;width:78px;"
    >
      <p class="g-pstyle5">1000km</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:75.4116%;margin-top:-8.7px;right:1.1644%;width:81px;"
    >
      <p class="g-pstyle4">2000km</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:94.5514%;margin-top:-16.7px;left:9.6542%;width:66px;"
    >
      <p class="g-pstyle6">IRON</p>
      <p class="g-pstyle6">DOME</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:94.5514%;margin-top:-16.7px;left:21.3123%;width:80px;"
    >
      <p class="g-pstyle6">DAVID&rsquo;S</p>
      <p class="g-pstyle6">SLING</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.4868%;margin-top:-8.7px;left:36.5148%;width:90px;"
    >
      <p class="g-pstyle6">ARROW 2</p>
    </div>
    <div
      id="g-ai3-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.4868%;margin-top:-8.7px;left:61.8539%;width:90px;"
    >
      <p class="g-pstyle6">ARROW 3</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2025-06-17 13:05 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-17 13:05 -->
<!-- ai file: israeldefenses.ai -->
<style lang="scss">
  #g-israeldefenses-box,
  #g-israeldefenses-box .g-artboard {
    margin: 0 auto;
  }
  #g-israeldefenses-box p {
    margin: 0;
  }
  #g-israeldefenses-box .g-aiAbs {
    position: absolute;
  }
  #g-israeldefenses-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-israeldefenses-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-israeldefenses-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-israeldefenses-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-israeldefenses-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-israeldefenses-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-israeldefenses-lg {
        display: block !important;
      }
    }
  }
  #g-israeldefenses-xs {
    position: relative;
    overflow: hidden;
  }
  #g-israeldefenses-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 300;
    font-style: normal;
    line-height: 12px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0.05em;
    font-size: 11px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    position: static;
  }
  #g-israeldefenses-xs .g-pstyle0 {
    font-weight: 400;
    height: 12px;
    padding-bottom: 3px;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: center;
  }
  #g-israeldefenses-xs .g-pstyle1 {
    font-style: italic;
    height: 12px;
    padding-bottom: 3px;
    text-align: center;
  }
  #g-israeldefenses-xs .g-pstyle2 {
    font-weight: 400;
    line-height: 11px;
    height: 11px;
    padding-bottom: 3px;
    letter-spacing: 0em;
    text-align: right;
  }
  #g-israeldefenses-xs .g-pstyle3 {
    font-weight: 500;
    height: 12px;
    padding-bottom: 3px;
    letter-spacing: 0em;
  }
  #g-israeldefenses-xs .g-pstyle4 {
    font-weight: 500;
    height: 12px;
    padding-bottom: 3px;
    letter-spacing: 0em;
    text-align: center;
  }
  #g-israeldefenses-xs .g-pstyle5 {
    font-weight: 500;
    height: 12px;
    padding-bottom: 3px;
    letter-spacing: 0em;
    text-align: right;
  }
  #g-israeldefenses-xs .g-pstyle6 {
    font-weight: 500;
    height: 12px;
    padding-bottom: 3px;
    letter-spacing: 0em;
    text-align: center;
    color: rgb(165, 15, 21);
  }
  #g-israeldefenses-xs .g-pstyle7 {
    font-weight: 500;
    height: 12px;
    padding-bottom: 3px;
    letter-spacing: 0em;
    color: rgb(165, 15, 21);
  }
  #g-israeldefenses-sm {
    position: relative;
    overflow: hidden;
  }
  #g-israeldefenses-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 500;
    line-height: 14px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(165, 15, 21);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-israeldefenses-sm .g-pstyle0 {
    font-weight: 400;
    height: 14px;
    padding-bottom: 5px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-israeldefenses-sm .g-pstyle1 {
    font-weight: 300;
    height: 14px;
    padding-bottom: 5px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-israeldefenses-sm .g-pstyle2 {
    font-weight: 300;
    font-style: italic;
    height: 14px;
    padding-bottom: 5px;
    letter-spacing: 0.05em;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-israeldefenses-sm .g-pstyle3 {
    font-weight: 400;
    height: 14px;
    padding-bottom: 5px;
    text-align: right;
    color: rgb(64, 64, 64);
  }
  #g-israeldefenses-sm .g-pstyle4 {
    height: 14px;
    padding-bottom: 5px;
    text-align: right;
    color: rgb(64, 64, 64);
  }
  #g-israeldefenses-sm .g-pstyle5 {
    height: 14px;
    padding-bottom: 5px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-israeldefenses-sm .g-pstyle6 {
    height: 14px;
    padding-bottom: 5px;
  }
  #g-israeldefenses-md {
    position: relative;
    overflow: hidden;
  }
  #g-israeldefenses-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 500;
    line-height: 15px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(165, 15, 21);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-israeldefenses-md .g-pstyle0 {
    font-weight: 400;
    height: 15px;
    padding-bottom: 6px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-israeldefenses-md .g-pstyle1 {
    font-weight: 300;
    height: 15px;
    padding-bottom: 6px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-israeldefenses-md .g-pstyle2 {
    font-weight: 300;
    font-style: italic;
    height: 15px;
    padding-bottom: 6px;
    letter-spacing: 0.05em;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-israeldefenses-md .g-pstyle3 {
    font-weight: 400;
    height: 15px;
    padding-bottom: 6px;
    text-align: right;
    color: rgb(64, 64, 64);
  }
  #g-israeldefenses-md .g-pstyle4 {
    height: 15px;
    padding-bottom: 6px;
    text-align: right;
    color: rgb(64, 64, 64);
  }
  #g-israeldefenses-md .g-pstyle5 {
    height: 15px;
    padding-bottom: 6px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-israeldefenses-md .g-pstyle6 {
    height: 15px;
    padding-bottom: 6px;
  }
  #g-israeldefenses-lg {
    position: relative;
    overflow: hidden;
  }
  #g-israeldefenses-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 500;
    line-height: 16px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(165, 15, 21);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-israeldefenses-lg .g-pstyle0 {
    font-weight: 400;
    height: 16px;
    padding-bottom: 9px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-israeldefenses-lg .g-pstyle1 {
    font-weight: 300;
    height: 16px;
    padding-bottom: 9px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-israeldefenses-lg .g-pstyle2 {
    font-weight: 300;
    font-style: italic;
    height: 16px;
    padding-bottom: 9px;
    letter-spacing: 0.05em;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-israeldefenses-lg .g-pstyle3 {
    font-weight: 400;
    height: 16px;
    padding-bottom: 9px;
    text-align: right;
    color: rgb(64, 64, 64);
  }
  #g-israeldefenses-lg .g-pstyle4 {
    height: 16px;
    padding-bottom: 9px;
    text-align: right;
    color: rgb(64, 64, 64);
  }
  #g-israeldefenses-lg .g-pstyle5 {
    height: 16px;
    padding-bottom: 9px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-israeldefenses-lg .g-pstyle6 {
    height: 16px;
    padding-bottom: 9px;
  }

  /* Custom CSS */
  .g-text {
  }
</style>
